module.exports = __webpack_public_path__ + "img/feature-bias-icon.1dc9d852.svg";